export const getCustomPromptListQuery = `
  query ListCustomPrompt($input: ListCustomPromptInputType) {
    listCustomPrompts(input: $input) {
    totalItems
      totalPages
      currentPage
      items {
        id
        createdAt
        title
        content
        specialty
        creationMethod
      }
    }
  }
`
// updatedAt

export const createCustomPromptQuery = `
  mutation CreateCustomPrompt($input: CreateCustomPromptInputType!) {
    createCustomPrompt(input: $input) {
      id
    }
  }
`

export const updateCustomPromptQuery = `
  mutation UpdateCustomPrompt($input: UpdateCustomPromptInputType!) {
    updateCustomPrompt(input: $input) {
      id
    }
  }
`

export const deactivateCustomPromptQuery = `
 mutation DeactivateCustomPrompt($input: DeactivateCustomPromptInputType!) {
  deactivateCustomPrompt(input: $input) {
    id
  }
}
`

export const getSpecialtyMarkdownQuery = `
  query GetMarkdownOfSpecialtiesAvailable($input: String!) {
    getMarkdownOfSpecialtiesAvailable(specialty: $input)
  }
`

export const generateCustomMarkdownQuery = `
  mutation GenerateMarkdown($input: String!) {
    generateMarkdown(instructions: $input)
  }
`
